export enum NewsArticleBlock {
  Root = 'NewsArticle',
}
